import { render, staticRenderFns } from "./ElectronicFenceInfo.vue?vue&type=template&id=43496a2b&scoped=true"
import script from "./ElectronicFenceInfo.vue?vue&type=script&lang=js"
export * from "./ElectronicFenceInfo.vue?vue&type=script&lang=js"
import style0 from "./ElectronicFenceInfo.vue?vue&type=style&index=0&id=43496a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43496a2b",
  null
  
)

export default component.exports